module.exports = __webpack_public_path__ + "static/media/cookie.ae0277d4.svg";